import { render, staticRenderFns } from "./DriverContractEntityDetails.vue?vue&type=template&id=fccc1db6&"
import script from "./DriverContractEntityDetails.vue?vue&type=script&lang=js&"
export * from "./DriverContractEntityDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fccc1db6')) {
      api.createRecord('fccc1db6', component.options)
    } else {
      api.reload('fccc1db6', component.options)
    }
    module.hot.accept("./DriverContractEntityDetails.vue?vue&type=template&id=fccc1db6&", function () {
      api.rerender('fccc1db6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DriverContractEntityDetails.vue"
export default component.exports